export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5072.712bb4b8.jpg";